/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AttachedDocumentTypeDirection {
  None = 0,
  Export = 1,
  Import = 2,
}
